import { ComponentProps } from "react";
import * as SelectPrimitive from "@radix-ui/react-select";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";
import { CommitmentStatusList } from "@/services/backend/relationships/types/relationship";
import { CommitmentStatusIcon } from "@/services/backend/relationships/components/commitment-status-icon";
import { cn } from "@/shared/lib/utils";

export function CommitmentStatusSelect({
  triggerClassName,
  ...props
}: ComponentProps<typeof SelectPrimitive.Root> & {
  triggerClassName?: string;
}) {
  return (
    <Select {...props}>
      <SelectTrigger className={cn(triggerClassName)}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="min-w-min">
        <SelectGroup>
          {CommitmentStatusList.map((status) => (
            <SelectItem value={status} key={status}>
              <CommitmentStatusIcon status={status} />
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
